import { JobsService, ShipmentsService } from '@/backend/market'
import { JobRepository } from '../../domain/repositories/JobRepository'
import { JobModel } from '../models/JobModel'
import type { JobShipmentInfoEntity } from '../../domain/entities/JobShipmentInfoEntity'
import { JobShipmentInfoModel } from '../models/JobShipmentInfoModel'
import type { JobFilterEntity } from '../../domain/entities/JobFilterEntity'
import { JobFilterModel } from '../models/JobFilterModel'
import { JobMiniModel } from '../models/JobMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { JobMiniEntity } from '../../domain/entities/JobMiniEntity'

export class JobRepositoryImpl implements JobRepository {
  async getJobDetail(): Promise<JobModel | { error: true }> {
    try {
      /// call api here like
      //   const otpRequestsFilterModel = new OtpRequestsFilterModel(filterData)
      // await OtpRequestsService.getOtpRequestsAdmin(otpRequestsFilterModel)
      const userModel = new JobModel({})

      return userModel
    } catch {
      return { error: true }
    }
  }
  async rearrangeJob(jobId: string): Promise<{ success: true } | { error: true }> {
    try {
      await ShipmentsService.postRearrangeShipmentsByJobIdAdmin({ jobId })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async getShipmentsByJobId(id: string): Promise<JobShipmentInfoEntity[] | { error: true }> {
    try {
      const response = await JobsService.getJobShipmentsDataAdmin({ id })
      const data = response.shipments.map((item) => new JobShipmentInfoModel(item))

      return data
    } catch {
      return { error: true }
    }
  }
  async getJobs(
    filter: JobFilterEntity
  ): Promise<PaginateEntity<JobMiniEntity[]> | { error: true }> {
    const filterModel = new JobFilterModel(filter)
    try {
      const response = await JobsService.getJobsAdmin(filterModel)
      const jobMiniModel = response.items?.map((item) => new JobMiniModel(item))
      const result = new PaginateEntity<JobMiniModel[]>(response, jobMiniModel)

      return result
    } catch {
      return { error: true }
    }
  }
  async recalculateDriverEarning(shipmentId: string): Promise<{ success: true } | { error: true }> {
    try {
      await ShipmentsService.postRecalculateDriverEarningAdmin({ id: shipmentId })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
